import { ChevronRightIcon } from "@heroicons/react/24/outline";
import classnames from "classnames";

export const DropArrow = ({ row, ...rest }) => {
  const classNames = classnames("w-4 h-4 cursor-pointer transition-transform", {
    "rotate-90": row.getIsExpanded(),
  });

  return (
    <button 
      className="cursor-pointer mr-2 flex items-center justify-center"
      onClick={(e) => {
        e.stopPropagation();
        row.toggleExpanded();
      }}
      aria-label={row.getIsExpanded() ? "Collapse row" : "Expand row"}
    >
      <ChevronRightIcon className={classNames} />
    </button>
  );
};

export default DropArrow;
